import "./style.scss";

import ProductCard from "../components/ProductCard";
import { Box } from "@mui/material";
import Pages from "../..";

import { callHttpClientMethod } from "../../../services/callHttpClient";
import {
  allPlants,
  category,
  listSize,
  special,
} from "../../../services/apiList";
import { BASE_URL, HttpMethod } from "../../../services/api.constant";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux";
import {
  memo,
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Category, Product, Size } from "../../../gobalType";
import { TypesAction } from "../../../redux/typesAction";

import FilterInMobile from "./FilterInMobile";
import { usePlantsFilter } from "./hooks/usePlantsFilter";
import { PlantsDesktopFilter } from "./components/PlantsDesktopFilter";
import { PlantsPageLoading } from "./components/PlantsPageLoading";
import { PlantsSpecialSection } from "./components/PlantsSpecialSection";
import { normalizePlantApiResponse } from "../../../utils/normalizePlantApiResponse";

const PlantsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const skipNextAllPlantsFetch = useRef(false);

  const { auth } = useSelector((state: RootState) => state.auth);
  const { product_lists } = useSelector((state: RootState) => state?.products);
  const dispatch = useDispatch();

  const [dataSpecial, setdataSpecial] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);

  const [categories, setCategories] = useState<Category[]>([]);
  const [allSize, setAllSize] = useState<Size[]>([]);

  const { arrchoicePlant, arrchoiceSize, handleChoicePlant, handleChoiceSize } =
    usePlantsFilter(categories, allSize);

  useLayoutEffect(() => {
    const explorerSpecialProducts = (
      location.state as { explorerSpecialProducts?: Product[] } | null
    )?.explorerSpecialProducts;
    if (!explorerSpecialProducts?.length) return;

    dispatch({
      type: TypesAction.GET_LIST_PRODUCTS,
      payload: { data: explorerSpecialProducts, loadingPf: false },
    });
    skipNextAllPlantsFetch.current = true;
    navigate(
      { pathname: location.pathname, search: location.search },
      { replace: true, state: {} }
    );
  }, [
    dispatch,
    location.pathname,
    location.search,
    location.state,
    navigate,
  ]);

  useEffect(() => {
    let cancelled = false;

    const loadInitial = async () => {
      setLoading(true);
      try {
        const [catsRes, sizesRes, specialRes] = await Promise.all([
          callHttpClientMethod(
            BASE_URL + category(),
            HttpMethod.Get,
            {},
            {}
          ),
          callHttpClientMethod(BASE_URL + listSize(), HttpMethod.Get, {}, {}),
          callHttpClientMethod(
            BASE_URL + special(),
            HttpMethod.Get,
            {},
            {
              headers: {
                Authorization: `Bearer ${auth?.access_token}`,
              },
            }
          ),
        ]);
        if (cancelled) return;
        setCategories(catsRes?.data);
        setAllSize(sizesRes?.data);
        setdataSpecial(normalizePlantApiResponse(specialRes));
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadInitial();
    return () => {
      cancelled = true;
    };
  }, [auth?.access_token]);

  const getListAllPlant = useCallback(async () => {
    const arrPlant = arrchoicePlant.includes(0) ? [] : arrchoicePlant;
    const arrSize = arrchoiceSize.includes("all") ? [] : arrchoiceSize;

    const data = {
      category_id: arrPlant,
      size_name: arrSize,
    };
    dispatch({
      type: TypesAction.GET_LIST_PRODUCTS,
      payload: { loadingPf: true },
    });
    try {
      const respon = await callHttpClientMethod(
        BASE_URL + allPlants(),
        HttpMethod.Get,
        data,
        {}
      );
      dispatch({
        type: TypesAction.GET_LIST_PRODUCTS,
        payload: { data: respon, loadingPf: false },
      });
    } catch {
      dispatch({
        type: TypesAction.GET_LIST_PRODUCTS,
        payload: { loadingPf: false },
      });
    }
  }, [arrchoicePlant, arrchoiceSize, dispatch]);

  useEffect(() => {
    if (skipNextAllPlantsFetch.current) {
      skipNextAllPlantsFetch.current = false;
      return;
    }
    getListAllPlant();
  }, [getListAllPlant]);

  if (loading) {
    return <PlantsPageLoading />;
  }

  const productCount = product_lists?.length ?? 0;

  return (
    <Pages>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          width: "100%",
          minWidth: 0,
          maxWidth: "100%",
        }}
      >
        <Box
          sx={{
            marginTop: { xs: 0, sm: "8px" },
            width: { xs: "100%", sm: "650px", md: "800px", lg: "981px" },
            maxWidth: "100%",
            boxSizing: "border-box",
            /* Padding thay cho margin filter — tránh width 100% + mx làm tràn ngang */
            px: { xs: 1.5, sm: 0 },
            minWidth: 0,
          }}
        >
          <Box
            className="info-products"
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "center",
              alignItems: { xs: "stretch", sm: "flex-start" },
              gap: { xs: 1.5, sm: 0 },
              width: "100%",
              minWidth: 0,
            }}
          >
            <FilterInMobile
              all_size={allSize}
              arrchoicePlant={arrchoicePlant}
              arrchoiceSize={arrchoiceSize}
              categories={categories}
              handleChoicePlant={handleChoicePlant}
              handleChoiceSize={handleChoiceSize}
            />
            <PlantsDesktopFilter
              categories={categories}
              allSize={allSize}
              arrchoicePlant={arrchoicePlant}
              arrchoiceSize={arrchoiceSize}
              productCount={productCount}
              onChoicePlant={handleChoicePlant}
              onChoiceSize={handleChoiceSize}
            />
            <Box
              sx={{
                width: "100%",
                minWidth: 0,
                maxWidth: "100%",
                flex: { sm: 1 },
              }}
            >
              <ProductCard
                selectedSizes={arrchoiceSize}
                allSize={allSize}
                listCategoryId={1}
              />
            </Box>
          </Box>

          <PlantsSpecialSection dataSpecial={dataSpecial} />
        </Box>
      </Box>
    </Pages>
  );
};

export default memo(PlantsPage);
